// extracted by mini-css-extract-plugin
export default {"bgimage":"BannerElement_bgimage__Qdfek","abs":"BannerElement_abs__ArFng","readmore":"BannerElement_readmore__bvRHK"};